import { HcResponseMeaning } from "./hc-response-meaning.enum";
import { HcResponseAction, HcTimeOutAction } from "./hc-response-actions.enum";

export interface HcSmsSetup {
  _id: string;
  csId: string;

  messageOptions: HcSmsMessageOptions;
  responseSetup: HcSmsResponseSetup;
  /** Stored for flows/UI; SMS completion uses `HcMessageStrings` keywords only (no Vertex AI). */
  enableAiInterpretation: boolean;
  saveSms: boolean;
  sendConfirmation?: boolean; // Send confirmation SMS back to loved one after they reply (default: true)
}

export interface HcSmsResponseSetup {
  entries: HcSmsResponseEntry[];
  timeout: number;
  timeoutAction: HcTimeOutAction;
}

export interface HcSmsResponseEntry {
  keywords: string[];
  phrases: string[];
  meaning: HcResponseMeaning;
  action: HcResponseAction;
}

export interface HcSmsMessageOptions {
  languageId: string; // Reference to HcLanguage
  greetingText: string; // Greeting message with mustache variables
  promptText: string; // Prompt message with mustache variables
  supportedVariables: HcSmsMustacheVariable[];
}

export enum HcSmsMustacheVariable {
  // User/Patient related
  PATIENT_NAME = '{{patient_name}}',
  PATIENT_FIRST_NAME = '{{patient_first_name}}',
  PATIENT_LAST_NAME = '{{patient_last_name}}',

  // Time related
  CURRENT_DATE = '{{current_date}}',
  CURRENT_TIME = '{{current_time}}',
  CURRENT_DAY = '{{current_day}}',
  CURRENT_MONTH = '{{current_month}}',
  CURRENT_YEAR = '{{current_year}}',

  // Health check related
  RESPONSE_DEADLINE = '{{response_deadline}}',
}

